import type { TMessages } from '@/types/TMessages'

export const messages = {
  caption: {
    conditions: 'Условия',
    creditSum: 'Сумма кредитования',
    creditSumv2: 'Сумма',
    percentRate: 'Процентная ставка',
    percentRatev2: 'Ставка',
    provision: 'Обеспечение по кредиту',
    provisionv2: 'Обеспечение',
    deadline: 'Срок',
    goal: 'Цель кредитования',
    form: 'Форма предоставления',
    typeOfCredit: 'Вид кредита',
    loanGoals: 'Цели',
    tranchTerms: 'Срок использования транша',
    paymentTerms: 'Как погашается',
    mainDiffrence: 'Главное отличие',
    peculiarities: 'Особенности',
    expenditureItems: 'Статьи расходов',
    deliveryTime: 'Интервал поставки',
    forWhom: 'Для кого',
    deliveryVolume: 'Объем поставки',
    advancePaymentSum: 'Сумма аванса',
    provisionVariants: 'Варианты обеспечения',
    priceVariants: 'Варианты ценообразования',
    rejects: 'Отказ от поставки / Поставка в неполном объеме',
  },
  title: {
    revolving: 'Оборотный кредит',
    investment: 'Инвестиционный',
    rules: 'Линейка «Урожайный бизнес»',
    preferentialLoan: 'Льготный кредит по Программе ПП РФ №1528',
  },
  text: {
    loanGoals: { alfaBank: 'Пополнение оборотных средств' },
    onlyForBusiness: 'Только для бизнеса <br/>в области растениеводства <br/>и животноводства',
    mainDiffrence: {
      alfaBank:
        '<ul class="list-with-marks"><li>Берите деньги частями в пределах лимита на срок до 6 месяцев</li><li>Погашайте кредит частично или полностью</li><li>После погашения ваш кредитный лимит возобновляется</li></ul>',
    },
    paymentTerm1: 'Проценты - каждый месяц, основной долг - последним платежом',
    paymentTerm2: 'Досрочное погашение бесплатно',
    typeOfCredit: 'Возобновляемая кредитная линия',
    creditSum: {
      first: "от 850 000 <br class='hidden-from-sm'/>до 500 000 000 рублей",
      second: "от 4 000 000 <br class='hidden-from-sm'/>до 150 000 000 рублей",
      oborotSber: {
        first: 'от 5 млн руб без залога и более с оформлением залога',
        second: 'до 1 млрд. руб. (в пределах максимальных лимитов субъектов РФ)',
      },
      investSber: {
        first: 'от 5 млн руб без залога и более с оформлением залога',
        second: 'без ограничений',
      },
      alfaBank1: 'от 500 000',
      alfaBank2: 'до 10 млн ₽',
      notice: '* до 6 млн ₽ без визита в отделение для ИП клиентов банка',
      centerInvestBankLoan: {
        first:
          '<p>до 1 млн руб - без залога под поручительство собственников бизнеса/супруга(и) ИП</p><p>более 1 млн руб. - под залог движимого или недвижимого имущества и поручительство собственников бизнеса/супруга(и) ИП</p>',
        second: 'до 1 млрд. руб. (в пределах максимальных лимитов субъектов РФ)',
      },
    },
    tranchTerms: 'от 1 до 6 месяцев',
    percentRate: {
      first: '<p>От 1 до 5% годовых по льготной программе Минсельхоза 1528</p>',
      second: 'От 1,5% в месяц',
      oborotSber: {
        first: '<h5>Целевой кредит</h5><p>от 13% годовых</p><h5>Общие условия</h5><p>от 17,5% до 19,5% годовых</p>',
        second: 'от 1 до 7% годовых',
      },
      investSber: {
        first: 'от 17,5 до 19,5% годовых',
        second: 'от 1 до 5% годовых',
      },
      notice: '* 18,9% годовых',
      landingConditionsTable: {
        first: 'от 18,5% до 20% годовых',
        second: 'от 1 до 5% годовых',
      },
      centerInvestBankLoan: {
        first: 'от 18,5% до 20% годовых',
        second: 'от 1 до 7% годовых',
      },
    },
    deadline: {
      revolving: '<p>До 36 мес.</p><p>До 12 мес. по льготной программе Минсельхоза 1528</p>',
      investSber: { first: 'до 10 лет', second: 'от 2 до 15 лет' },
      first: { oborotSber: 'до 3 лет' },
      second: { oborotSber: 'до 12 месяцев' },
      investment: {
        first: 'От 2 до 12 лет<br/>До 12 мес. по льготной программе Минсельхоза 1528',
        second: 'От 2 до 7 лет<br/>До 12 мес. по льготной программе Минсельхоза 1528',
      },
      landingConditionsTable: {
        first: '<h5>Оборотный кредит</h5><p>до 3 лет</p><h5>Инвестиционный кредит</h5><p>до 10 лет</p>',
        second: '<h5>Оборотный кредит</h5><p>до 1 года</p><h5>Инвестиционный кредит</h5><p>от 2 до 5 лет</p>',
      },
      centerInvestBankLoan: {
        first: '<h5>Оборотный кредит</h5><p>до 3 лет</p><h5>Инвестиционный кредит</h5><p>до 10 лет</p>',
        second: '<h5>Оборотный кредит</h5><p>до 1 года</p><h5>Инвестиционный кредит</h5><p>от 2 до 5 лет</p>',
      },
    },
    peculiarities: {
      first: {
        oborotSber: 'Упрощённый анализ финансовой деятельности заёмщика',
      },
      second: {
        oborotSber: 'Договор о финансировании подписывается после согласования заявки с Минсельхозом России',
      },
      investSber: {
        first: 'Требуется страхование залога',
        second:
          '<ul class="list-with-marks"><li>Договор о финансировании подписывается после согласования заявки с Минсельхозом России</li><li>Срок рассмотрения заявки Минсельхозом России — до 7 рабочих дней</li></ul>',
      },
      centerInvestBankLoan: {
        first: 'Упрощенный пакет документов',
        second: 'Договор о финансировании подписывается после согласования заявки с Минсельхозом России',
      },
    },
    goal: {
      revolving: {
        first:
          '<p>Финансирование текущей деятельности:</p> <ul class="list-with-marks"><li>Приобретение сырья, товаров, материалов, комплектующих</li><li>Оплата работ и услуг, выплаты заработной платы</li><li>Уплата налоговых платежей и сборов</li><li>Иные расходы в рамках осуществления текущей деятельности.</li></ul>',
        second:
          '<p class="space-holder-top32-from-sm space-holder-top16-sm">Перечень направлений целевого использования льготных  краткосрочных кредитов размещен на сайте Министерства сельского хозяйства РФ</p>',
      },
      investment: {
        first: 'Приобретение имущества, ремонт/реконструкция, развитие нового направления деятельности',
        second:
          'Льготная программа Минсельхоза 1528 доступна для приобретения целевого перечня техники или строительства целевого перечня недвижимости',
      },
    },
    form: '<ul class="list-with-marks"><li>Разовый кредит (классическая форма кредитования с графиком платежей)</li><li>Возобновляемая кредитная линия (кредит с возможностью неоднократного использования и погашения нескольких траншей в рамках установленных сроков и сумм)</li><li>Невозобновляемая кредитная линия (кредит с возможностью единоразового использования и погашения нескольких траншей в рамках установленных сроков и сумм)</li></ul>',
    provision: {
      first: '<p>Поручительство собственников бизнеса, участников заемщика – ФЛ, связанных компаний.<p>',
      second:
        '<h5>Залог имущества</h5><p>(транспорт, недвижимость, в. т.ч. оборудование, поручительство Фондов/гарантия Корпорации МСП приравниваются к залогу недвижимости)</p>',
      third: '<h5>Возможность предоставить залог в форме с/хоз земель</h5>',
      alfaBank:
        '<ul class="list-with-marks"><li>Страхование не требуется</li><li>Залог не требуется</li><li>Требуется поручительство физического лица</li></ul>',
      investSber:
        '<ul class="list-with-marks"><li>Имущественное обеспечение ИЛИ</li><li>Поручительство физических и/или юридических лиц</li></ul>',
    },
    expenditureItems:
      '<ul class="list-with-marks"><li>Любые виды закупок для нужд сельхозтоваропроизводителя</li><li>Обслуживание и модернизация помещений и парка техники</li><li>Любые статьи, связанные с крупными расходами на ведение бизнеса</li></ul>',
    deliveryTime: 'По мере уборки урожая (с начала июля по конец октября – в зависимости от региона)',
    forWhom: '<p>Для ИП и ЮЛ</p>',
    deliveryVolume: {
      withoutGuarantee: '<strong>До 70%</strong> от целевой культуры, выращиваемой хозяйством',
      withGuarantee: '<strong>До 100%</strong> потенциального урожая',
    },
    advancePaymentSum: {
      withoutGuarantee: '<strong>До 70%</strong> от стоимости контрактуемого товара',
      withGuarantee: '<strong>До 100%</strong> от стоимости контрактуемого товара (но не более суммы одобренной банковской гарантии) ',
    },
    provisionVariants: {
      withoutGuarantee:
        '<ul class="list-with-marks"><li>Залог продукции будущего урожая в объеме поставки</li><li>Личное поручительство бенефициара или Поручительство/Гарантия компании бенефициара (по требованию)\n</li></ul>',
      withGuarantee: 'Банковская гарантия',
    },
    priceVariants:
      '<ul class="list-with-marks"><li>Цена фиксируется в момент начала поставки по прайсу ООО «Деметра Трейдинг», на базисе CPT соответствующего элеватора «Деметра-Холдинг»</li><li>Цена фиксируется в момент начала поставки товара на основе сложившихся цен на товарных аукционах «НТБ»</li></ul>',
    rejects:
      '<p><strong>В случае срыва поставки (поставки не в полном объеме) поставщик обязуется:</strong> <br/> <ul class="list-with-marks"><li>Вернуть часть аванса, не закрытую совершенными поставками, с начислением процентов по ставке 20% годовых с даты получения аванса;</li><li>Уплатить неустойку за непоставленный товар, в размере пропорционально непоставленному объему</li></ul>',
    innerHeading: {
      revolving: 'Инвестиционный',
      rules: 'Линейка «Урожайный бизнес»',
      withoutGuarantee: 'Без гарантии банка',
      withGuarantee: 'С банковской гарантией ',
      investment: 'Инвестиционный',
      preferentialLoan: 'Льготный кредит по Программе ПП РФ №1528',
    },
    mobileHeader: {
      centerInvestBankLoan: {
        first: 'Оборотный кредит',
        second: 'Льготный кредит по Программе ПП РФ №1528',
      },
    },
  },
} satisfies TMessages
